import type { TFunction } from 'i18next'

import type { RelatedDocument } from '../../types/relatedDocument'
import type { RelatedInvoice } from '../../types/relatedInvoice'
import { getRelatedInvoiceDocumentName } from '../getRelatedInvoiceDocumentName'
import { getRelatedInvoiceDocumentType } from './getRelatedInvoiceDocumentType'

export const getRelatedDocumentFromRelatedInvoice = (
  relatedInvoice: RelatedInvoice,
  t: TFunction,
): RelatedDocument => ({
  billingStage: relatedInvoice.billingStage,
  documentId: String(relatedInvoice.invoiceId ?? relatedInvoice.invoiceDraftId),
  documentName: getRelatedInvoiceDocumentName(relatedInvoice, t),
  documentType: getRelatedInvoiceDocumentType(relatedInvoice),
})
